import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "label-badge",
  templateUrl: "./label-badge.component.html",
  styleUrls: ["./label-badge.component.scss"]
})
export class LabelBadgeComponent implements OnInit {
  @Input()
  labels: any;

  @Input()
  size: string;

  constructor() {}

  ngOnInit() {}
}
